import { BaseOntarioObstetricalFileSubSection, BaseOntarioObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/Ontario/Subcomponent/BaseOntarioObstetricalFileSubSection";

class OntarioObstetricalFileExamAsIndicated extends BaseOntarioObstetricalFileSubSection<BaseOntarioObstetricalFileSubSectionProps, never> {
    public render(): JSX.Element {
        const indicatedExam = this.props.form.Opr2.ExamAsIndicated;

        return (
            <div className="row border border-top">
                <div className="col-md-12">
                    <div className="section">
                        {this.renderSubTitle("ObstetricalFile_ExamAsIndicatedLabel", "margin-none-bottom")}
                        {!this.props.readonly && (
                            <p>
                                <a onClick={() => this.props.mutateModelStateWithFormUpdate(s => s.Opr2.ExamAsIndicated.setEmptyExamsAsNormal())}>
                                    {this.getString("ObstetricalFile_MarkAllEmptyFieldsAsNormalLabel")}
                                </a>
                            </p>
                        )}
                        <div className="row row-form margin-sm-top">
                            {this.renderRadioButtonField(
                                "ObstetricalFile_HeadAndNeckLabel",
                                this.controlRenderer.renderNormalAbnormalRadio(
                                    indicatedExam.HeadAndNeckExamState,
                                    value => this.props.mutateModelStateWithFormUpdate(s => s.Opr2.ExamAsIndicated.HeadAndNeckExamState = value),
                                    "ExamAsIndicated_HeadAndNeck"
                                ),
                                "col-md-4"
                            )}
                            {this.renderRadioButtonField(
                                "AbdomenLabel",
                                this.controlRenderer.renderNormalAbnormalRadio(
                                    indicatedExam.AbdomenExamState,
                                    value => this.props.mutateModelStateWithFormUpdate(s => s.Opr2.ExamAsIndicated.AbdomenExamState = value),
                                    "ExamAsIndicated_Abdomen"
                                ),
                                "col-md-4"
                            )}
                            {this.renderRadioButtonField(
                                "ObstetricalFile_BreastNipplesLabel",
                                this.controlRenderer.renderNormalAbnormalRadio(
                                    indicatedExam.BreastNipplesExamState,
                                    value => this.props.mutateModelStateWithFormUpdate(s => s.Opr2.ExamAsIndicated.BreastNipplesExamState = value),
                                    "ExamAsIndicated_Breast"
                                ),
                                "col-md-4"
                            )}
                        </div>
                        <div className="row row-form">
                            {this.renderRadioButtonField(
                                "ObstetricalFile_HeartLungsLabel",
                                this.controlRenderer.renderNormalAbnormalRadio(
                                    indicatedExam.HeartLungsExamState,
                                    value => this.props.mutateModelStateWithFormUpdate(s => s.Opr2.ExamAsIndicated.HeartLungsExamState = value),
                                    "ExamAsIndicated_HeartLungs"
                                ),
                                "col-md-4"
                            )}
                            {this.renderRadioButtonField(
                                "MusculoskeletalAbbreviationLabel",
                                this.controlRenderer.renderNormalAbnormalRadio(
                                    indicatedExam.MusculoskeletalExamState,
                                    value => this.props.mutateModelStateWithFormUpdate(s => s.Opr2.ExamAsIndicated.MusculoskeletalExamState = value),
                                    "ExamAsIndicated_MSK"
                                ),
                                "col-md-4"
                            )}
                            {this.renderRadioButtonField(
                                "PelvicLabel",
                                this.controlRenderer.renderNormalAbnormalRadio(
                                    indicatedExam.PelvicExamState,
                                    value => this.props.mutateModelStateWithFormUpdate(s => s.Opr2.ExamAsIndicated.PelvicExamState = value),
                                    "ExamAsIndicated_Pelvic"
                                ),
                                "col-md-4"
                            )}
                        </div>
                        <div className="row">
                            {this.renderRadioButtonField(
                                "OtherLabel",
                                this.controlRenderer.renderNormalAbnormalRadio(
                                    indicatedExam.OtherExamState,
                                    value => this.props.mutateModelStateWithFormUpdate(s => s.Opr2.ExamAsIndicated.OtherExamState = value),
                                    "ExamAsIndicated_Other"
                                ),
                                "col-md-4"
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export { OntarioObstetricalFileExamAsIndicated };
